import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconHome = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6139 4.54414C12.2528 4.26328 11.7472 4.26328 11.3861 4.54414L5.38606 9.21081C5.14247 9.40027 5 9.69157 5 10.0002V17.3335C5 18.6222 6.04467 19.6668 7.33333 19.6668H16.6667C17.9553 19.6668 19 18.6222 19 17.3335V10.0002C19 9.69157 18.8575 9.40027 18.6139 9.21081L12.6139 4.54414ZM7 17.3335V10.4892L12 6.60036L17 10.4892V17.3335C17 17.5176 16.8508 17.6668 16.6667 17.6668H15V12.0001C15 11.4478 14.5523 11.0001 14 11.0001H10C9.44772 11.0001 9 11.4478 9 12.0001V17.6668H7.33333C7.14924 17.6668 7 17.5176 7 17.3335ZM11 17.6668H13V13.0001H11V17.6668Z"
        />
      </svg>
    );
  }
);
